import React, {Component, createRef} from 'react';

// CSS
import './Subscription.scss';

// Helper
import {setCookie, checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Panel, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Properties
const properties = require('../../properties.json');

class AddPeriod extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        // Submit Button
        buttonText: "إضافة فترة",
        buttonColor: "",
        grade: null,
        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        teacherId : null ,
        periodName: null ,
        globalFilter: null,

        // ---- the add form, in its own panel ----
        // These used to be shared with the edit dialog, which is why editing a
        // period picked up whatever was typed up here. Add and edit each keep
        // their own now.
        addOpen: false,
        userInput : null ,
        selectedPeriod: null ,
        material: null,
        saving: false,

        // ---- the edit form, its own state, filled from the row ----
        editRow: null,
        editName: null,
        editParent: null,
        editMaterial: null,
        editSaving: false,

        // Get Data
        data:[],
        dataId:[],
        selectedPeriodId: null ,

        // every material the teacher has, each with its stage name on it --
        // the options for the one material field both forms share
        allMaterials: [],

        // id -> name, so a row can name the material it belongs to instead of
        // showing the number the response carries
        materialsById: {},

        // The rows are on their way. Until they arrive the table says so,
        // instead of claiming there are none.
        tableLoading: true,

        // The period the teacher asked to delete, held while the confirm is on
        // screen. The delete behind it is the same call it always was.
        doomed: null,
        deleting: false,

        // the one menu that waits on its options
        loadingMaterials: true,
    }

     getPeriods(){
        this.setState({ tableLoading: true });
        apiFetch("/periods")
        .then(grades => {
            this.setState({data : grades, tableLoading: false});
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ tableLoading: false });
        });
     }

     // Same lookup AllLessons already calls, so a row can say "الجبر" rather
     // than the material's id.
     // Every material the teacher has, each one carrying its own stage name.
     // That is the whole menu: a period belongs to a material, and the stage
     // was only ever a way of narrowing the list to find one -- which costs a
     // field, and leaves an edit form unable to show the material it already
     // has, because a period row carries no stage to narrow by.
     getMaterials = () => {
        const user = getCurrentUser();
        this.setState({ loadingMaterials: true });
        apiFetch("/lookup/materials", { query: { branchId: user?.branchId, teacherUserId: user?.userId } })
        .then(materials => {
            const materialsById = {};
            materials.forEach(m => { materialsById[m.id] = m.name; });
            this.setState({ materialsById, allMaterials: materials, loadingMaterials: false });
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ loadingMaterials: false });
        });
     }

    componentDidMount () {
        document.title = properties.site_name + " | إضافة فترة جديدة";
        this.getPeriods();
        this.getMaterials();
       // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }
    }

     addPeriod = () => {
         var _this = this ;
        this.setState({ saving: true, buttonText: "جاري الإضافة ...", buttonColor: "loading" });
        // Send the data to the server
        apiFetch("/periods", {
            method: "POST",
            body: {
                name: this.state.userInput,
                branchId: this.state.branchID,
                materialId: this.state.material,
                parentId: this.state.selectedPeriod,
            },
        })
        .then(() => {
            _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تمت الإضافة بنجاح'});
            // the save finished the job, so the panel closes and the table
            // behind it goes and fetches what was just added
            _this.setState({
                saving: false,
                buttonText: "إضافة فترة",
                buttonColor: "",
                addOpen: false,
                userInput: null,
                selectedPeriod: null,
                material: null,
            });
            this.getPeriods();
        })
        .catch(error => {
            console.error('Error:', error)
            _this.setState({ saving: false, buttonText: "إضافة فترة", buttonColor: "" });
            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
        });
    }

    // The pencil opens a form that already holds the period's own values. It
    // used to open blank and share the add box's state, so saving without
    // retyping sent an empty name and the other form's material.
    openEdit = (row) => {
        this.setState({
            editRow: row,
            editName: row.name || "",
            editParent: row.parentId || null,
            editMaterial: row.materialId || null,
        });
    }

    closeEdit = () => {
        this.setState({ editRow: null });
        this.getPeriods();
    }

    render() {

        let  periods = this.state.data.map(period => {
            return {label: period.name, value: period.id}});

        // One menu for both forms. Each material carries its own stage name
        // (MaterialResponse.stageName), so "عربي" under two stages is still
        // told apart without a second field to narrow it down.
        const materials = this.state.allMaterials.map(material => {
            return {
                label: material.stageName ? `${material.name} — ${material.stageName}` : material.name,
                value: material.id,
            };
        });

        const { tableLoading, doomed, deleting, editRow } = this.state;

        var deletePeriod = (e) => {
            var _this = this;
            this.setState({ deleting: true });
            // Send the data to the server
            apiFetch(`/periods/${e.id}`, { method: "DELETE" })
            .then(() => {
                this.setState({ doomed: null, deleting: false });
                this.getPeriods();
                _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم الحذف بنجاح'});
            })
            .catch(error => {
                console.error('Error:', error)
                this.setState({ doomed: null, deleting: false });
                _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
            });
        }

        // Adding a period is something you do on this page now, not a row of
        // controls wedged into the table's own header.
        const openAdd = () => this.setState({ addOpen: true });
        const closeAdd = () => {
            this.setState({ addOpen: false });
            this.getPeriods();
        };

        // The save stays out of reach until the form can actually be saved.
        const filled = (v) => v !== null && v !== undefined && String(v).trim() !== "";
        const canSave = filled(this.state.userInput) && filled(this.state.material);
        const canSaveEdit = filled(this.state.editName);

        // a period's parent, by name -- the response carries only its id, and
        // the names are already on this page
        const parentName = (id) => {
            if (!id) return null;
            const found = this.state.data.find((p) => p.id === id);
            return found ? found.name : null;
        };

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="تعديل">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-ml-2" onClick={() => this.openEdit(rowData)} />
                    </Tip>
                    <Tip text="حذف">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        // the period as the teacher recognises it: its name, and the period it
        // hangs off under it when it has one
        const nameBody = (row) => {
            const parent = parentName(row.parentId);
            return (
                <span className="ui-stack">
                    <b>{row.name || "—"}</b>
                    <small>{parent ? `تحت: ${parent}` : "فترة رئيسية"}</small>
                </span>
            );
        };

        const edit =(id) => {
            var _this = this ;
            this.setState({ editSaving: true });
            // Send the data to the server. Same call, same four fields -- they
            // are just read from the edit form's own state now, which starts
            // out holding the row's values.
            apiFetch(`/periods/${id}`, {
                method: "PUT",
                body: {
                    name: this.state.editName,
                    branchId: this.state.branchID,
                    materialId: this.state.editMaterial,
                    parentId: this.state.editParent,
                },
            })
            .then(() => {
                _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم التعديل بنجاح'});
                _this.setState({ editSaving: false });
                _this.closeEdit();
            })
            .catch(error => {
                console.error('Error:', error)
                _this.setState({ editSaving: false });
                _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
            });
        }

        return (
            <>
                <Header
                    pageName="الفترات"
                    action={{ label: "إضافة فترة", icon: "pi pi-plus", onClick: openAdd }}
                />
                <Toast ref={this.toast}></Toast>

                {/* The add form used to be five controls crammed into the
                    table's header row. Same fields, same handler, same call --
                    they just have room to be read now. */}
                <Panel
                    visible={this.state.addOpen}
                    onHide={closeAdd}
                    title="إضافة فترة"
                    subtitle="اختار المادة وسمّي الفترة، وهتظهر في الجدول بعد الحفظ"
                    actions={
                        <Button
                            className={`add-button ${this.state.buttonColor}`}
                            label={this.state.buttonText}
                            disabled={!canSave || this.state.saving}
                            onClick={() => this.addPeriod()}
                        />
                    }
                >
                    <div className="add-lesson-page in-panel">
                        <div className="content">
                            <div className="container">
                                <section className="ui-sec" style={{ "--d": "0ms" }}>
                                    <h3>
                                        <span className="n">١</span>
                                        <span className="t">
                                            المادة
                                            <small>الفترة بتتبع مادة — كل مادة مكتوب جنبها مرحلتها</small>
                                        </span>
                                    </h3>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <Dropdown
                                                        value={this.state.material}
                                                        options={materials}
                                                        placeholder="اختر"
                                                        onChange={(e) => this.setState({ material: e.value })}
                                                        name="subject"
                                                        showClear
                                                        emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                                                    />
                                                    <label>المادة</label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="ui-sec" style={{ "--d": "70ms" }}>
                                    <h3>
                                        <span className="n">٢</span>
                                        <span className="t">
                                            الفترة
                                            <small>سمّي الفترة، وحطها تحت فترة رئيسية لو هي جزء منها</small>
                                        </span>
                                    </h3>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        id="period-name"
                                                        value={this.state.userInput || ""}
                                                        onChange={(e) => this.setState({ userInput: e.target.value })}
                                                        placeholder="مثال: الترم الأول"
                                                    />
                                                    <label htmlFor="period-name">إسم الفترة</label>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <Dropdown
                                                        value={this.state.selectedPeriod}
                                                        options={periods}
                                                        placeholder="اختر"
                                                        onChange={(e) => this.setState({selectedPeriod : e.value})}
                                                        optionLabel="label"
                                                        showClear
                                                    />
                                                    <label>
                                                        الفترة الرئيسية
                                                        <small className="ui-fieldhint">اختيارية — سيبها فاضية لو دي فترة رئيسية</small>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </Panel>

                {/* Editing opens the same shape as adding, holding the row's
                    own values. */}
                <Panel
                    visible={!!editRow}
                    onHide={this.closeEdit}
                    title="تعديل الفترة"
                    subtitle="عدّل البيانات واحفظ، والجدول هيتحدّث لوحده"
                    actions={
                        <Button
                            className="add-button"
                            label={this.state.editSaving ? "جاري الحفظ ..." : "حفظ التعديل"}
                            disabled={!canSaveEdit || this.state.editSaving}
                            onClick={() => (editRow ? edit(editRow.id) : null)}
                        />
                    }
                >
                    {editRow ? (
                        <div className="add-lesson-page in-panel">
                            <div className="content">
                                <div className="container">
                                    <section className="ui-sec" style={{ "--d": "0ms" }}>
                                        <h3>
                                            <span className="n">١</span>
                                            <span className="t">
                                                الفترة
                                                <small>إسم الفترة، والفترة الرئيسية اللي بتتبعها</small>
                                            </span>
                                        </h3>
                                        <div className="p-grid p-fluid">
                                            <div className="p-col-12 p-md-4">
                                                <div className="p-inputgroup">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            id="edit-period-name"
                                                            value={this.state.editName || ""}
                                                            onChange={(e) => this.setState({ editName: e.target.value })}
                                                        />
                                                        <label htmlFor="edit-period-name">إسم الفترة</label>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="p-col-12 p-md-4">
                                                <div className="p-inputgroup">
                                                    <span className="p-float-label">
                                                        <Dropdown
                                                            value={this.state.editParent}
                                                            // a period cannot be its own parent
                                                            options={periods.filter((p) => p.value !== editRow.id)}
                                                            placeholder="اختر"
                                                            onChange={(e) => this.setState({ editParent: e.value })}
                                                            optionLabel="label"
                                                            showClear
                                                        />
                                                        <label>
                                                            الفترة الرئيسية
                                                            <small className="ui-fieldhint">اختيارية — سيبها فاضية لو دي فترة رئيسية</small>
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Same one field as the add form, opened on
                                        the material the period already has. */}
                                    <section className="ui-sec" style={{ "--d": "70ms" }}>
                                        <h3>
                                            <span className="n">٢</span>
                                            <span className="t">
                                                المادة
                                                <small>الفترة بتتبع مادة — كل مادة مكتوب جنبها مرحلتها</small>
                                            </span>
                                        </h3>
                                        <div className="p-grid p-fluid">
                                            <div className="p-col-12 p-md-4">
                                                <div className="p-inputgroup">
                                                    <span className="p-float-label">
                                                        <Dropdown
                                                            value={this.state.editMaterial}
                                                            options={materials}
                                                            placeholder="اختر"
                                                            onChange={(e) => this.setState({ editMaterial: e.value })}
                                                            showClear
                                                            emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                                                        />
                                                        <label>المادة</label>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </Panel>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? doomed.name : ""}
                    note="الفترة هتتشال نهائياً، والفترات اللي تحتها والإشتراكات المرتبطة بيها ممكن تتأثر."
                    busy={deleting}
                    onConfirm={() => deletePeriod(doomed)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                {/* search over the same globalFilter the table always read */}
                                <Toolbar
                                    value={this.state.globalFilter || ""}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في الفترات"
                                    count={tableLoading ? null : `${this.state.data.length} فترة`}
                                />

                                <DataTable
                                sortable
                                globalFilter={this.state.globalFilter}
                                 className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                  value={this.state.data} paginator rows={10} rowsPerPageOptions={[10,20,50]}
                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                   emptyMessage={
                                       tableLoading ? (
                                           <TableWait />
                                       ) : (
                                           <EmptyState
                                               title="لا يوجد فترات"
                                               hint="ابدأ بإضافة أول فترة لمادة من موادك"
                                               icon="pi pi-calendar"
                                               action={{ label: "إضافة فترة", onClick: openAdd }}
                                           />
                                       )
                                   }>
                                    <Column sortable field="name" body={nameBody} header="الفترة"></Column>
                                    <Column
                                        sortable
                                        field="materialId"
                                        body={(row) => this.state.materialsById[row.materialId] || "—"}
                                        header="المادة"
                                    ></Column>
                                    <Column header="تعديل / حذف"
                                    body={actionBodyTemplate}
                                    ></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AddPeriod;
